const COMPANIES = {
  LIST: 'list_companies',
  SHOW: 'show_company',
  CREATE: 'create_company',
  UPDATE: 'edit_company',
  DELETE: 'destroy_company',
  LIST_COMPANY_STEPS: 'list_companies_steps',
  EXPORT_LIST: 'list_companies_steps',
  INACTIVE_AND_ACTIVE: 'change_company_status',
  UPDATE_SELF: 'update_self_company',
  SHOW_LOGS: 'logs_company',
  EXPORT_DATA_PROCESSES: 'export_processes',
  UPDATE_DEMO_PARTNER: 'change_demo_partner',
}

const COMPANY_SUPPLIERS = {
  LIST: 'list_company_suppliers',
  SHOW: 'show_company_supplier',
  UPDATE: 'update_company_supplier',
  DESTROY: 'destroy_company_supplier',
}

const INCIDENTS = {
  LIST: 'list_incidents',
  CREATE: 'create_incident',
  INACTIVATE: 'inactivate_incident',
}

const DATA_PROCESSES = {
  LIST: 'list_data_processes',
  CREATE: 'create_data_process',
  INACTIVE_AND_REACTIVE: 'inactive_and_reactive_data_process',
  DESTROY: 'destroy_data_process',
  REVIEW: 'review_data_process',
  REOPEN: 'reopen_data_process',
  LIST_AND_MANAGE_SUGGESTED: 'list_and_manage_suggested_data_processes',
  MANAGE_LEGAL_FRAMEWORKS: 'index_with_legal_frameworks',
  COPY: 'copy_many_data_processes',
  SOFT_DELETE: 'soft_delete_data_process',
}

const NON_COMPLIANCE_REPORT = {
  LIST: 'list_non_compliance_reports',
  RESUME: 'resume_non_compliance_report',
  EDIT: 'edit_non_compliance_report',
  HANDLE_ACTIONS: 'handle_non_compliance_reports_actions',
  HANDLE_SPECIFIC_RISKS: 'handle_specific_risks',
  LIST_DATA_PROCESSES: 'list_all_non_compliance_report_data_process',
  LIST_LINKED_DATA_PROCESS: 'list_linked_non_compliance_report_data_process',
  LIST_QUESTIONNAIRE: 'list_all_non_compliance_report_by_questionnaire',
  LIST_LINKED_QUESTIONNAIRE:
    'list_linked_non_compliance_report_by_questionnaire',
  LIST_INCIDENT: 'list_incident_non_compliance_reports',
  LIST_RESPONSIBLE: 'list_responsable_non_compliance_reports',
}

const USERS = {
  SHOW: 'show_user',
  LIST: 'list_users',
  CREATE: 'create_user',
  EDIT: 'edit_user',
  DESTROY: 'destroy_user',
  CHANGE_STATUS: 'change_user_status',
  EXPORT: 'export_users',
  TEMP_PASSWORD: 'generate_user_temporary_password',
}

const COLLABORATORS = {
  SHOW: 'show_user_collaborator',
  LIST: 'list_user_collaborators',
  CREATE: 'create_user_collaborator',
  EDIT: 'edit_user_collaborator',
  CHANGE_STATUS: 'change_user_collaborator_status',
  EXPORT: 'export_user_collaborators',
}

const CLIENT_PROFILES = {
  LIST: 'list_client_profiles',
  CREATE: 'create_client_profile',
  EDIT: 'edit_client_profile',
  DESTROY: 'destroy_client_profile',
  CHANGE_STATUS: 'change_status_client_profile',
}

const COLLABORATOR_PROFILES = {
  LIST: 'list_collaborator_profiles',
  CREATE: 'create_collaborator_profile',
  EDIT: 'edit_collaborator_profile',
  DESTROY: 'destroy_collaborator_profile',
  CHANGE_STATUS: 'change_status_collaborator_profile',
}

const COUPONS = {
  LIST: 'list_discount_coupons',
  CREATE: 'create_discount_coupon',
  DESTROY: 'destroy_discount_coupon',
  SHOW_LOGS: 'show_discount_coupon_logs',
}

const DEPARTMENT = {
  LIST: 'list_departments',
  CREATE: 'create_department',
  LINK_USERS: 'link_users_to_department',
  ACTIVATE_OR_INACTIVATE: 'activate_or_inactivate_department',
}

const QUESTIONNAIRES = {
  REPLY: 'reply_questionnaire',
  LINK_USERS: 'link_users',

  // Advisor
  VIEW: 'show_organization_quiz_template',
  MANAGE: 'update_organization_quiz_template',
}

const RIPD = {
  EXPORT: 'export_ripd',
  EXPORT_ADMIN: 'export_ripd_admin',
}

const DASHBOARD = {
  VIEW: 'view_dashboard',
  VIEW_PROCESS: 'view_dashboard_process',
  VIEW_RMC: 'view_dashboard_rnc',
  VIEW_QUESTIONNAIRE: 'view_dashboard_gap',
}

const EXPORT_INFO = {
  EXPORT_RIPD: 'export_ripd',
}

const EXPORT_RIPD = {
  EXPORT_RIPD_ADMIN: 'export_ripd_admin',
}

const PRIVACY_POLICY = {
  LIST: 'list_privacy_policy',
  CREATE: 'create_privacy_policy',
  STAMP: 'stamp_privacy_policy',
}

const QUESTIONNAIRE_BY_COMPANY = {
  LIST: 'list_all_questionnaires',
  CREATE: 'create_questionnaire',
  EDIT: 'update_questionnaire',
  COPY: 'copy_questionnaires',
}

const QUESTION = {
  CREATE: 'create_question',
  UPDATE: 'update_question',
  INACTIVATE: 'inactivate_question',
}

const FORM_OPTIONS = {
  LIST: 'list_select_options',
  CREATE: 'create_select_option',
  EDIT: 'update_select_option',
  DESTROY: 'destroy_select_option',
}

const LEGAL_FRAMEWORKS = {
  LIST: 'list_legal_frameworks',
  EDIT: 'update_legal_framework',

  // Advisor
  MANAGE: 'change_status_data_process',
}

const ANPD_CONTACTS = {
  LIST: 'list_anpd_contacts',
  CREATE: 'create_anpd_contact',
  EDIT: 'edit_anpd_contact',
  DESTROY: 'destroy_anpd_contact',
}

const DOCUMENTATION_LINKS = {
  LIST: 'list_documentation_links',
  CREATE: 'create_documentation_link',
  EDIT: 'edit_documentation_link',
  DESTROY: 'destroy_documentation_link',
}

const GROUPS = {
  LIST: 'list_groups',
  CREATE: 'create_group',
  EDIT: 'edit_group',
  DESTROY: 'destroy_group',
  ACTIVATE_OR_INACTIVATE: 'change_status_group',
}

const SUBGROUPS = {
  LIST: 'list_subgroups',
  CREATE: 'create_subgroup',
  EDIT: 'edit_subgroup',
  DESTROY: 'destroy_subgroup',
  ACTIVATE_OR_INACTIVATE: 'change_status_subgroup',
}

const SEGMENTS = {
  LIST: 'list_segments',
  CREATE: 'create_segment',
  EDIT: 'edit_segment',
  DESTROY: 'destroy_segment',
  ACTIVATE_OR_INACTIVATE: 'change_status_segment',
}

const COMPANY_SIZES = {
  LIST: 'list_company_sizes',
  CREATE: 'create_company_size',
  EDIT: 'edit_company_size',
  DESTROY: 'destroy_company_size',
  ACTIVATE_OR_INACTIVATE: 'change_status_company_size',
}

const ECONOMIC_ACTIVITIES = {
  LIST: 'list_economic_activities',
  CREATE: 'create_economic_activity',
  EDIT: 'edit_economic_activity',
  DESTROY: 'destroy_economic_activity',
  ACTIVATE_OR_INACTIVATE: 'change_status_economic_activity',
}

const PERMISSIONS_PRIVATE_DOCUMENTS_LABEL = {
  LIST_PRIVATE_DOCUMENT: 'Ver Documentos Privados',
}

const PERMISSIONS_DEFAULT_LABEL = {
  LIST: 'Listar',
  CREATE: 'Criar',
  EDIT: 'Editar',
  DESTROY: 'Deletar',
  COPY: 'Copiar',
  ACTIVATE_OR_INACTIVATE: 'Ativar/Inativar',
  SHOW: 'Exibir',
  MANAGE: 'Gerenciar',
  VISUALIZE: 'Visualizar',
  MANAGE_PAYMENT: 'Gerenciar pagamento',
  INVOICE: 'Faturar contrato',
}

const PERMISSIONS_INCIDENTS_LABEL = {
  INACTIVATE: 'Inativar',
}

const PLANS = {
  LIST: 'list_plans',
  CREATE: 'create_plan',
  DESTROY: 'destroy_plan',
}

const PRE_REGISTRATIONS = {
  CREATE: 'create_backoffice_pre_registration',
  LIST: 'list_pre_registrations',
  DESTROY: 'destroy_pre_registration',
}

const PAYMENT_CONTRACTS = {
  MANAGE: 'create_payment_contract',
  LIST: 'list_payment_contracts',
  SHOW: 'show_payment_contract',
  INVOICE: 'invoice_payment_contract',
  DESTROY: 'destroy_payment_contract',
}

const PAYMENT_ORDERS = {
  MANAGE_PAYMENT: 'create_payment_order',
  LIST: 'list_payment_orders',
}

const DOCUMENTS = {
  LIST: 'list_documents',
  CREATE: 'create_document',
  EDIT: 'update_document',
  DESTROY: 'destroy_document',
  CATEGORY_LIST: 'list_document_categories',
  LIST_PRIVATE_DOCUMENTS: 'list_private_documents',
}

const LAST_UPDATES = {
  LIST: 'list_last_updates',
  SHOW: 'show_last_update',
  CREATE: 'create_last_update',
  EDIT: 'edit_last_update',
  DESTROY: 'destroy_last_update',
}

const FAQS_DOCUMENTATIONS = {
  CREATE: 'create_faqs_documentation',
  EDIT: 'edit_faqs_documentation',
  DESTROY: 'destroy_faqs_documentation',
}

const DOCUMENTS_TEMPLATE = {
  LIST: 'list_old_document_templates',
  CREATE: 'create_old_document_template',
  EDIT: 'update_old_document_template',
  DESTROY: 'destroy_old_document_template',
  CATEGORY_LIST: 'list_document_categories',
}

const COMPLAINTS = {
  LIST: 'list_complaints',
  SHOW: 'show_complaint',
  REGISTER_RESPONSIBLE: 'register_responsible_complaint',
  ACTIVATE_COMPLAINTS: 'activate_complaints',
  LIST_CONFIGURATIONS: 'list_complaint_configurations',
  MANAGE_CONFIGURATIONS: 'manage_complaint_configurations',
}

const COMPLAINT_MESSAGES = {
  CREATE: 'create_complaint_message',
}

const TRANSLATED_CLIENT_PERMISSIONS_LIST = {
  changesManagementList: 'Gestão de Mudanças',
  companyList: 'Dados cadastrais da empresa',
  companySupplierList: 'Fornecedores',
  complaintList: 'Canal de denúncias',
  dashboardList: 'Minha LGPD',
  dataProcessList: 'Processos',
  departmentList: 'Departamentos',
  diagnosticsList: 'Diagnóstico',
  documentList: 'Documentos',
  documentTemplateList: 'Modelos de Documento',
  financialList: 'Painel Financeiro da Empresa',
  incidentList: 'Incidentes',
  lastUpdatesList: 'Últimas Atualizações',
  monitoringManagementKpiList: 'Gestão de Monitoramento KPI',
  monitoringManagementNcList: 'Gestão de Monitoramento NC',
  monitoringManagementPmcList: 'Gestão de Monitoramento PMC',
  nonComplianceReportList: 'Registros de melhoria contínua',
  privacyPolicyList: 'Políticas de Privacidade',
  profileList: 'Perfis',
  questionnaireList: 'Questionários',
  ripdList: 'Relatório de Impacto à Proteção de Dados',
  userList: 'Usuários',
  smtpCredentialList: 'Credenciais SMTP',
  monitoringManagementPdcaList: 'PDCAs',
  changesManagementList: 'Gestão de mudanças',
}

const TRANSLATED_COLLABORATOR_PERMISSIONS_LIST = {
  anpdContactList: 'Contatos ANPD',
  churnList: 'Churn',
  clientProfileList: 'Perfis de Usuários',
  collaboratorList: 'Colaboradores',
  collaboratorProfileList: 'Perfis de Colaboradores',
  companyList: 'Empresas',
  companySizeList: 'Tamanho da Empresa',
  companySupplierList: 'Fornecedores',
  couponList: 'Cupons',
  dataProcessList: 'Processos',
  departmentList: 'Departamentos',
  documentationLinkList: 'Links de Ajuda',
  economicActivityList: 'Atividades Econômicas',
  exportInfoList: 'Exportar Informações',
  exportRipdList: 'Exportar RIPD',
  formOptionList: 'Opções de Formulários',
  groupList: 'Grupos',
  incidentList: 'Incidentes',
  legalFrameworkList: 'Enquadramento Legal',
  organizationList: 'Grupos Advisor',
  paymentContractList: 'Contratos de Pagamento',
  paymentOrdersList: 'Ordens de Pagamento',
  planList: 'Planos',
  preRegistrationList: 'Clientes e sublicenciamentos',
  privacyPolicyList: 'Políticas de Privacidade',
  questionnaireByCompanyList: 'Questionários por Empresa',
  reportList: 'Relatórios',
  rmcListingList: 'Listagem de RMC',
  rmcResumeList: 'Resumo de RMC',
  segmentList: 'Segmentos',
  sellerList: 'Vendedores & Parceiros',
  subgroupList: 'Subgrupos',
  userList: 'Usuários',
  ssoCorporateGroupList: 'Grupos Empresariais com Login SSO-SAML',
  smtpCredentialList: 'Credenciais SMTP',
}

const TRANSLATED_ADVISOR_PERMISSIONS_LIST = {
  dataProcessTemplateList: 'Modelos de Processos',
  documentTemplateList: 'Modelos de Documentos',
  incidentList: 'Incidentes',
  juridicTicketList: 'Tickets Jurídicos',
  legalFrameworkList: 'Enquadramento Legal',
  legitimateInterestList: 'Interesse Legítimo',
  observerOrganizationList: 'Grupos Advisor Observadores',
  organizationCompanyList: 'Empresas do Grupo Advisor',
  organizationList: 'Grupos Advisor',
  privacyPortalConfigurationList: 'Configuração do Portal de Privacidade',
  profileList: 'Perfis',
  questionnaireList: 'Questionários',
  solicitationTicketList: 'Tickets de Solicitação',
  tagList: 'Classificadores',
  taskList: 'Tarefas',
}

const DIAGNOSTICS = {
  UPDATE: 'update_question_control',
  TAKE_RISK: 'take_risk_question_control',
  OPEN_WRITE: 'open_write_question_control',
}

const SELLERS = {
  CREATE: 'create_seller',
  LIST: 'list_sellers',
  SHOW: 'show_seller',
  MANAGE_COMMISSION: 'create_transfer_commision',
  DESTROY: 'destroy_seller',
}

const CHURNS = {
  MANAGE: 'create_churn',
  LIST: 'list_churn',
  SHOW: 'show_churn',
}

const FINANCIAL_CLIENT = {
  MANAGE: 'index_by_company_payment_order',
}

const SSO_CORPORATE_GROUP = {
  LIST: 'list_sso_corporate_groups',
  SHOW: 'show_sso_corporate_group',
  CREATE: 'create_sso_corporate_group',
  EDIT: 'edit_sso_corporate_group',
  DESTROY: 'destroy_sso_corporate_group',
}

const SMTP_CREDENTIAL = {
  MANAGE: 'create_smtp_credential',
}

const PRIVACY_BY_DESIGN = {
  LIST: 'list_privacy_by_design',
  MANAGE: 'create_privacy_by_design',
}

const CHANGES_MANAGEMENT = {
  LIST: 'list_changes_management',
  MANAGE: 'create_changes_management',
}

// ========================= Advisor =========================

const ADVISOR_PROFILE = {
  VIEW: 'show_advisor_profile',
  MANAGE: 'update_advisor_profile',
}

const ORGANIZATION = {
  VIEW: 'list_organizations',
  MANAGE: 'update_organization',
}

const ORGANIZATION_COMPANY = {
  VIEW: 'show_organization_company',
  MANAGE: 'update_organization_company',
}

const TAG = {
  VIEW: 'show_tag',
  MANAGE: 'create_tag',
}

const ORGANIZATION_USER = {
  VIEW: 'show_organization_user',
  LIST: 'list_organization_user',
  MANAGE: 'create_organization_user',
}

const PRIVACY_PORTAL_CONFIGURATION = {
  MANAGE_FORM: 'update_question_option_ticket',
  MANAGE_THEME: 'manage_privacy_portal_theme',
  VIEW_FORM: 'list_question_option_ticket',
}

const SOLICITATION_TICKET = {
  VIEW: 'show_solicitation_ticket',
  MANAGE: 'update_solicitation_ticket',
}

const TASKS = {
  VIEW: 'list_tasks',
  CREATE: 'create_task',
  UPDATE: 'update_task',
  DESTROY: 'destroy_task',
}

const JURIDIC_TICKET = {
  VIEW: 'show_juridic_ticket',
  MANAGE: 'update_juridic_ticket',
}

const CLIENT_PORTAL_THEME = {
  VIEW: 'show_client_portal_theme',
  MANAGE: 'update_client_portal_theme',
}

const OBSERVERS_ORGANIZATIONS = {
  MANAGE_OBSERVERS_INCIDENT: 'edit_allow_observers_incident',
  MANAGE_OBSERVERS_TICKET: 'edit_allow_observers_ticket',
}

const LEGITIMATE_INTEREST = {
  LIST: 'list_data_process_status_lia',
  SHOW: 'list_lia_questions_with_answers',
  MANAGE: 'reply_lia_questions_dpo',
  USE_TEMPLATE: 'reply_lia_questions_with_template',
}

const DATA_PROCESS_TEMPLATE = {
  MANAGE: 'create_data_process_template',
  VIEW: 'show_data_process_template',
}

const ADVISOR_DOCUMENT_TEMPLATE = {
  MANAGE: 'create_document_template',
  VIEW: 'list_document_templates',
}

const MONITORING_MANAGEMENT_KPI = {
  LIST: 'list_monitoring_management_kpi',
  MANAGE: 'create_monitoring_management_kpi',
}
const MONITORING_MANAGEMENT_PDCA = {
  LIST: 'index_pdcas',
  MANAGE: 'create_pdca',
}

const MONITORING_MANAGEMENT_NC = {
  LIST: 'list_monitoring_management_nc',
  MANAGE: 'create_monitoring_management_nc',
}

const MONITORING_MANAGEMENT_PMC = {
  LIST: 'list_monitoring_management_pmc',
  MANAGE: 'create_monitoring_management_pmc',
}

const permissions = {
  ADVISOR_DOCUMENT_TEMPLATE,
  ADVISOR_PROFILE,
  ANPD_CONTACTS,
  CHANGES_MANAGEMENT,
  CHURNS,
  CLIENT_PORTAL_THEME,
  CLIENT_PROFILES,
  COLLABORATOR_PROFILES,
  COLLABORATORS,
  COMPANIES,
  COMPANY_SIZES,
  COMPANY_SUPPLIERS,
  COMPLAINT_MESSAGES,
  COMPLAINTS,
  COUPONS,
  DASHBOARD,
  DATA_PROCESS_TEMPLATE,
  DATA_PROCESSES,
  DEPARTMENT,
  DIAGNOSTICS,
  DOCUMENTATION_LINKS,
  DOCUMENTS_TEMPLATE,
  DOCUMENTS,
  ECONOMIC_ACTIVITIES,
  EXPORT_INFO,
  EXPORT_RIPD,
  FAQS_DOCUMENTATIONS,
  FINANCIAL_CLIENT,
  FORM_OPTIONS,
  GROUPS,
  INCIDENTS,
  JURIDIC_TICKET,
  LAST_UPDATES,
  LEGAL_FRAMEWORKS,
  LEGITIMATE_INTEREST,
  MONITORING_MANAGEMENT_KPI,
  MONITORING_MANAGEMENT_NC,
  MONITORING_MANAGEMENT_PDCA,
  MONITORING_MANAGEMENT_PMC,
  NON_COMPLIANCE_REPORT,
  OBSERVERS_ORGANIZATIONS,
  ORGANIZATION_COMPANY,
  ORGANIZATION_USER,
  ORGANIZATION,
  PAYMENT_CONTRACTS,
  PAYMENT_ORDERS,
  PERMISSIONS_DEFAULT_LABEL,
  PERMISSIONS_INCIDENTS_LABEL,
  PERMISSIONS_PRIVATE_DOCUMENTS_LABEL,
  PLANS,
  PRE_REGISTRATIONS,
  PRIVACY_BY_DESIGN,
  PRIVACY_POLICY,
  PRIVACY_PORTAL_CONFIGURATION,
  QUESTION,
  QUESTIONNAIRE_BY_COMPANY,
  QUESTIONNAIRES,
  RIPD,
  SEGMENTS,
  SELLERS,
  SMTP_CREDENTIAL,
  SOLICITATION_TICKET,
  SSO_CORPORATE_GROUP,
  SUBGROUPS,
  TAG,
  TASKS,
  TRANSLATED_ADVISOR_PERMISSIONS_LIST,
  TRANSLATED_CLIENT_PERMISSIONS_LIST,
  TRANSLATED_COLLABORATOR_PERMISSIONS_LIST,
  USERS,
}

export default permissions
